<script setup>
/* eslint-disable */
import { onMounted, ref } from "vue"

import Header from "../components/Home/headerHome.vue"
import MobileMenu from "../components/Common/mobileMenu.vue"
import Footer from "../components/Common/Footer.vue"
import PromoCard from "../components/Home/PromoCard.vue"
import LiveNow from "../components/Home/LiveNow.vue"
import HeroBanner from "../components/Home/HeroBanner.vue"
import TodaysCoupons from "../components/Home/TodaysCoupons.vue"
import Games from "../components/Home/GamesCard.vue"
import { useRouter } from 'vue-router'
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import SportsbookMissions from "@/components/modals/missions/SportsbookMissions.vue"
import { EditBetSlip } from '@/stores/edit_betslip';
import MyEditBetsSlips from '@/views/Bets/MyEditBetsSlips.vue';
import LandingQuickPicks from '@/components/Home/sports/LandingQuickPicks.vue'
import LandingHighlights from '@/components/Home/sports/Highlights.vue'
// import TopCompetitions from "../components/Home/competitions.vue"

import MyBetsSlips from "./Bets/MyBetsSlips.vue"
import { useCustomerStore } from "@/stores/customer";
import { useGeneralStore } from '@/stores/general';
import { useInitializeStore } from '@/stores/initialize';
import { useI18n } from 'vue-i18n';
import { useMenuStore } from "@/stores/menus";
import { openModal } from "@kolirt/vue-modal";
import { useThemeStore } from '@/stores/themes';

import Login from "@/components/modals/Login.vue";
import VerificationEmail from "@/components/modals/VerificationEmail.vue";
import  { usePlatformConfigurationStore }  from '@/stores/platform_configuration'
import { useLaternaStore } from '@/stores/laterna';
import SharedBetslipInputModal from "@/components/modals/share_bet/SharedBetslipInputModal.vue"
import LaternaBanners from "@/components/landing/laterna/Banners.vue"

import { useBannersStore } from "@/stores/banners"
const { t } = useI18n();
const router = useRouter();
const generalStore = useGeneralStore();
const menuStore = useMenuStore();
const customerStore = useCustomerStore();
const initializeStore = useInitializeStore();
const editBetslipStore = EditBetSlip();
const themeStore = useThemeStore();
const laternaStore = useLaternaStore();
const platformConfigurationStore = usePlatformConfigurationStore();
const bannersStore = useBannersStore();

const goTo = (path) => {
	if (!path) return;
	if (path == '/missions') {
		openModal(SportsbookMissions, {mission_type: 'all'}).catch(() => {});
		return;
	}

	if (path == '#/pre-sports' || path == '/pre-sports') {
		router.push({ name: 'pre-sports-coupons', params: { sport_id: '' } });
		return;
	}

	if (path == '/bet-influencer/share') {
		openModal(SharedBetslipInputModal).catch(() => {});
		return;
	}


	let login_required = (path.includes('/account') || path.includes('/casino/game/') || path.includes('/live-casino/table/'));
	let verification_required = (path.includes('/account') || path.includes('/casino/game/') || path.includes('/live-casino/table/'));

	if (login_required && !customerStore.isLoggedIn) openModal(Login).catch(() => {});
	else if (verification_required && !customerStore.hasVerifiedEmail) openModal(VerificationEmail).catch(() => {});
	else router.push(path);
}


const getMenuStyle = (menu_item) => {
	if (menu_item.linear_background_primary && menu_item.linear_background_secondary) {
		return `background: linear-gradient( to bottom, ${menu_item.linear_background_primary}, ${menu_item.linear_background_secondary} );`
	}
}

const large_landing_menus = ref(false);
onMounted(() => {
	large_landing_menus.value = platformConfigurationStore.hasLargeLandingMenu;
	document.title = generalStore.getGeneral.site_name + ' - ' +  t('general.home');
})
</script>

<template>
<Header></Header>

<!-- fixed mobile bottom menu-->
<div class="fixed-btm-main">
	<div class="container-full fix-padding">
		<MobileMenu></MobileMenu>
	</div>
</div>

<!-------- banner start--------->
<HeroBanner class="home_banner" v-if="!platformConfigurationStore.isLaternaBannersEnabled"></HeroBanner>
<LaternaBanners v-else/>

<!-------- banner end--------->

<!-- small boxes start -->

<section class="nav-boxes-main" :class="{ 'background': themeStore.is_near_white_theme }" v-if="menuStore.getLandingPageMenu.length > 0" :style="bannersStore.homepage_banners.length == 0 ? {paddingTop: '50px', marginTop: 'unset'} : ''">
	<div class="container-full">
		<div class="nav-boxes-main">
			<div class="nav-box-item" :class="{'item-large': large_landing_menus, 'background': themeStore.is_near_white_theme }" v-for="menu_item in menuStore.getLandingPageMenu" @click="goTo(menu_item.click_url)" :style="getMenuStyle(menu_item)">
				<img :src="menu_item.media_url" width="24">
				<p>{{ menu_item.name }}</p>
			</div>
		</div>
	</div>
</section>

<!-- small boxes end -->


<!---------promo card start----------->
<section v-if="!platformConfigurationStore.isLaternaBannersEnabled" class="promo-sec-main" :style="bannersStore.homepage_banners.length == 0 ? {paddingTop: '50px', marginTop: 'unset'} : ''">
	<div class="promos-container">
		<PromoCard></PromoCard>
	</div>
</section>

<!---------promo card end----------->

<!---------live score start----------->

<div v-if="platformConfigurationStore.isLaternaEnabled" class="laterna" :class="{'paddings': bannersStore.homepage_banners.length == 0 && initializeStore.screenWidth > 991}">
	<template v-for="page_section in laternaStore.getLandingPageSections" :key="page_section.id">
		<component :is="laternaStore.getRegistry[page_section.type]" :section="page_section"/>
	</template>
</div>
<template v-else>

	<section class="coupon-section-main">
		<div class="container-lg">
			<!-- coupon logo slider start-->
			<div class="title coupon-title">
				<h3>{{$t('general.todays_coupons')}}</h3>
			</div>
			<div class="coupon-slider">
				<TodaysCoupons></TodaysCoupons>
			</div>
			<!-- coupon logo slider end-->
		</div>
	</section>


	<section class="live-score-pannel">
		<div class="container-lg">
			<div class="title">
				<h2><img src="@/assets/images/live-score-ico.svg" alt="live score icon">&nbsp;{{$t('general.live_now')}}</h2>
			</div>
			<!-- score slider card start-->
			<div class="live-score-main">
				<LiveNow></LiveNow>
			</div>
			<!-- score slider card end-->
		</div>
	</section>

	<section class="game-section">
		<div class="container-lg">
			<div class="games-main-section">
				<div class="title games-title">
					<h3>{{$t('general.games')}}</h3>
				</div>
				<div class="games-slider">
					<Games></Games>
				</div>
			</div>
		</div>
	</section>


</template>

<!-- footer start -->
<MyEditBetsSlips v-if="initializeStore.isSportsbookEnabled && editBetslipStore.edit_mode_enabled" />
<MyBetsSlips v-if="initializeStore.isSportsbookEnabled && !editBetslipStore.edit_mode_enabled"/>

<Footer></Footer>

<!-- footer end -->
</template>

<style scoped>


.nav-box-item.background {
	background: var(--landing-boxes);
	border: 1px solid var(--landing-boxes) !important;
}
.coupon-title {
	color:var(--landing-header-text-color-dark-section);
}
.games-title {
	color:var(--landing-header-text-color-light-section);
}

.paddings {
	padding-top: 120px !important;
}
.promos-container {
	margin-top: -150px;
	max-width: 1496px;
    margin-left: auto;
    margin-right: auto;
}

.laterna {
	padding-top: 50px;
	max-width: 1496px;
    margin-left: auto;
    margin-right: auto;
    /* padding-left: 20px; */
    /* padding-right: 20px; */
	padding-bottom: 30px;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.laterna {
		padding-top: 20px;
		padding-left: 20px;
    	padding-right: 20px;
	}
	.games-main-section {
		padding-top: 15px;
		padding-bottom: 20px
	}
	.game-section .container-lg {
		padding-right: 12px;
		padding-left: 12px;
	}
	.coupon-section-main .container-lg {
		padding-right: 12px;
		padding-left: 12px;
	}

	.container-lg.laterna {
		background: var(--dark-gray)
	}

}

.container-lg.laterna {
		padding-top: 20px;
	}

.games-main-section h3 {
	text-align: center;
	text-transform: uppercase;
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.games-main-section h3 {
		font-size: 20px;
	}

}

@media screen and (min-width: 992px) and (max-width: 1190px) {
	.games-main-section h3 {
		font-size: 18px;
	}
}

@media screen and (min-width: 992px) and (max-width: 1359px) {
	.games-main-section h3 {
		font-size: 20px;
	}
}

@media screen and (min-width: 1360px) and (max-width: 1439px) {
	.games-main-section h3 {
		font-size: 22px;
	}
}

@media screen and (min-width: 1440px) and (max-width: 1599px) {
	.games-main-section h3 {
		font-size: 24px;
	}
}
html[dir="rtl"] .fix-padding {
		padding-left: unset;
		padding-right: unset;
	}

.sport-container-home {
	padding-left: 12px;
	padding-right: 12px;
}

.nav-box-item.item-large {
	height: 120px !important
}

.nav-box-item.item-large img {
	width: 50%;
}

.nav-box-item.item-large {
	gap: 15% !important
}

.nav-box-item.item-large p{
	font-size: 12px !important;
	text-align: center !important;
}


</style>
